import { PartitionLoopCompareJCountHIState } from "./PartitionLoopCompareJCountHIState";
import { assertIsDefined } from "../../../tsutils/assertIsDefined";
import { IQuickSortState } from "../../IQuickSortState";
import { QuickSortStep } from "../../enums/QuickSortStep";
import { IQuickSortContext } from "../../IQuickSortContext";

export class PartitionLoopIncrementJCountState implements IQuickSortState {
  
  ThisQuickSortStep = QuickSortStep.PartitionLoopIncrementJCount;

  Description = "Increment j value";

  private _savedState : { JCount : number | undefined } | undefined;

  private _context : IQuickSortContext | undefined;

  SetContext(context: IQuickSortContext): void {
    this._context = context;
  }  
  
  Do(): void { 
    if (this._context && this._context.JCount !== undefined) {
      
      if (this._savedState === undefined) {
        this._savedState = {
          JCount: this._context.JCount
        }
      }
      else {
        this._savedState.JCount = this._context.JCount;
      }

      this._context.JCount++;
    }
  }

  Undo(): void {
    if (this._savedState && this._context) {
      this._context.JCount = this._savedState.JCount;
    }
  }

  Exit(): void {
    if (this._context !== undefined) {
      this._context.TransitionTo(new PartitionLoopCompareJCountHIState());
      return;
    }
  }
}